/**
 * LO rates API wrapper
 */

import { api } from "../common/utils"
import {
  RATEFLOW_COMPARE_ENDPOINT,
  RATEFLOW_ENDPOINT,
  RATEFLOW_LOG_ENDPOINT,
  RATEFLOW_PRICE_ENDPOINT,
  RATEFLOW_SCENARIO_ENDPOINT,
  LOAN_SUMMARY_PDF_ENDPOINT
} from "../common/constants"
import { APIError, RateflowLogPdfData } from "../types"

const rateflow = {
  get: async (params: any) => {
    // check if params empty
    if (!Object.keys(params).length) {
      const { data } = await api.get(RATEFLOW_ENDPOINT, {
        params: { default: true }
      })
      return data
    }
    const { data } = await api.get(RATEFLOW_ENDPOINT, params)
    return data
  },
  // rateflowData={
  //      owner*
  //      loid
  //      id*
  //      settings:{
  //          target_price
  //          cache_ttl
  //      }
  //      pricing_set_id
  //      bank_id
  //      name
  // }
  updateOrAdd: async (rateflowData: any) => {
    const { data } = await api.post(RATEFLOW_ENDPOINT, rateflowData)
    return data
  },
  // params = {
  //      id*
  //      loid
  //      include_trend
  //      max_results
  //      ignore_cache
  //      list_price
  //      min_credit
  // }
  price: async (params: any) => {
    if (!params.id && !params.loid) {
      throw new Error("rateflow id or loid is required")
    }
    const { data } = await api.get(RATEFLOW_PRICE_ENDPOINT, { params })
    return data
  },
  // params = {
  //      id*
  // 		credit_score
  // 		loan_purpose
  // 		amortization_type
  // 		arm_term
  // 		aus
  // 		lock_period
  // 		loan_amount
  // 		down_payment
  // 		lead_source
  // 		loan_term
  // 		loan_type
  // 		list_price
  // 		county
  // 		street
  // 		state
  //		zipcode
  // }
  priceCustom: async (params: any) => {
    if (!params.id && !params.loid) {
      throw new Error("rateflow id missing")
    }

    const { data } = await api.post(RATEFLOW_PRICE_ENDPOINT, params)
    return data
  },
  log: async (log_id: string | string[]) => {
    const id_param = Array.isArray(log_id) ? log_id.join(",") : log_id
    const { data } = await api.get(RATEFLOW_LOG_ENDPOINT, {
      params: { id: id_param, include_request: true, include_cards: true }
    })
    return data
  },
  compare: async (quote_id: string) => {
    const { data } = await api.get(RATEFLOW_COMPARE_ENDPOINT, {
      params: { quote_id }
    })
    return data
  },
  logSearch: async (params?: any) => {
    const { data } = await api.get(RATEFLOW_LOG_ENDPOINT, { params })
    return data
  },
  defaultScenarios: async (params: any) => {
    const { data } = await api.get(RATEFLOW_SCENARIO_ENDPOINT, { params })
    return data
  },
  generatePDF: async (params?: any): Promise<RateflowLogPdfData | APIError> => {
    const { data } = await api.get(LOAN_SUMMARY_PDF_ENDPOINT, { params })
    return data
  },
  delete: async (id: string): Promise<{ status: string; message?: string }> => {
    const { data } = await api.delete(`${RATEFLOW_ENDPOINT}?id=${id}`)
    return data
  }
}

export default rateflow
